import React, {Component} from 'react';
import { NavLink } from "react-router-dom";
import { Trans } from 'react-i18next';
import Icon from "./Icon";

class SearchTabs extends Component {
  render() {
    return (
      <div className="venue-finder-tabs">
        <NavLink to={"/map"}
                 activeClassName="is-map"
                 className="venue-finder-tabs__toggle button">
          <span className="button__icon button__icon--standalone">
            <Icon iconId="map"/>
          </span>
          <span className="button__text">
            <Trans i18nKey="search_tabs.label_map">Map</Trans>
          </span>
        </NavLink>
        <NavLink to={"/list"}
                 activeClassName="is-list"
                 className="venue-finder-tabs__toggle venue-finder-tabs__toggle--list button">
          <span className="button__icon button__icon--standalone">
            <Icon iconId="grid"/>
          </span>
          <span className="button__text">
            <Trans i18nKey="search_tabs.label_grid">Grid</Trans>
          </span>
        </NavLink>
      </div>
    );
  }
}

export default SearchTabs;

